import type { OrganizationQuery } from "src/graphql";
import type { AiFeatureSettings } from "src/hooks/use-ai-feature-settings";
import { createTypedOutlet } from "src/router";

export type OrganizationOutletContext = {
  organization: Omit<
    NonNullable<OrganizationQuery["organizations_by_pk"]>,
    "ai_feature_settings"
  > & {
    ai_feature_settings: AiFeatureSettings;
  };
};

const {
  OutletProvider: OrganizationOutlet,
  useContext: useOrganizationOutletContext,
  useOptionalContext: useOrganizationOutletContextIfAvailable,
} = createTypedOutlet<OrganizationOutletContext>("Organization");

export {
  OrganizationOutlet,
  useOrganizationOutletContext,
  useOrganizationOutletContextIfAvailable,
};
